import { render, staticRenderFns } from "./checkItem.vue?vue&type=template&id=b9a23312&scoped=true&"
import script from "./checkItem.vue?vue&type=script&lang=js&"
export * from "./checkItem.vue?vue&type=script&lang=js&"
import style0 from "./checkItem.vue?vue&type=style&index=0&id=b9a23312&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9a23312",
  null
  
)

export default component.exports